import { useEffect, useRef, useState } from 'react';

export default function GabrielSantosDemo() {
  // ====== CONFIGURAÇÕES - EDITE AQUI ======
  const AGENT_ID = 'f470c0d1-814a-40ab-91d4-fad0827f6c68';
  const API_KEY = 'pawsf_7abeec3a730fb75d3cca261f14b099ef';
  const SITE_URL = 'https://quora-frontend-cl3.kinddesert-624c9557.brazilsouth.azurecontainerapps.io'; // URL do seu site
  // ========================================
  const iframeRef = useRef(null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Modifica o viewport dinamicamente
  useEffect(() => {
    // Encontra a meta tag viewport existente
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    
    if (viewportMeta) {
      // Salva o valor original para restaurar depois
      const originalContent = viewportMeta.getAttribute('content');
      
      // Atualiza para incluir viewport-fit=cover
      viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0, viewport-fit=cover');
      
      // Cleanup: restaura o valor original quando o componente desmontar
      return () => {
        viewportMeta.setAttribute('content', originalContent);
      };
    }
  }, []);

  /**
   * Handle iframe communication
   */
  useEffect(() => {
    const handleMessage = (event) => {
      const iframe = iframeRef.current;
      if (!iframe) return;

      switch (event.data.type) {
        case "agent-chat-resize":
          // Aplica TODOS os estilos enviados pelo iframe
          iframe.style.width = event.data.width;
          iframe.style.height = event.data.height;
          iframe.style.bottom = event.data.bottom;
          iframe.style.right = event.data.right;
          iframe.style.borderRadius = event.data.borderRadius;
          break;

        case "agent-chat-opened":
          setIsChatOpen(true);
          break;

        case "agent-chat-closed":
          setIsChatOpen(false);
          break;

        case "agent-chat-ready":
          // Detecta mobile no parent e envia para o iframe
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
                          || window.innerWidth <= 768;
          
          iframe.contentWindow.postMessage({
            type: 'parent-info',
            isMobile: isMobile,
            screenWidth: window.innerWidth
          }, '*');
          break;
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Seu conteúdo da página aqui */}
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Demo Bigens
        </h1>
        <p className="text-lg text-gray-600">
          Esta é uma página de demonstração do chat widget para Bigens.
        </p>
      </div>

      {/* Chat Widget Iframe */}
      <iframe
        ref={iframeRef}
        id="agent-chat-widget"
        src={`${SITE_URL}/agent-chat/iframe/${AGENT_ID}?apiKey=${API_KEY}`}
        style={{
          position: 'fixed',
          border: 'none',
          zIndex: 9999,
          bottom: '20px',
          right: '20px',
          transition: 'all 0.3s ease',
          borderRadius: '20px',
        }}
      />
    </div>
  );
}